import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import NotFound from "./components/not-found/not-found";
import Splash from "./components/splash/splash";
import AuthenticationHome from "./authentication/authentication-home";
import AuthenticationMobile from "./authentication/authentication-mobile";
import AuthenticationCode from "./authentication/authentication-code";
import Dashboard from "./components/dashboard/dashboard";
import Profile from "./components/profile/profile";
import ReleaseHome from "./components/releases/home/home";
import ReleaseDetail from "./components/releases/detail/detail";
import ReleaseNote from "./components/releases/detail/release-note";
import ReleaseList from "./components/releases/list/list";

class Routes extends Component {
  state = {};
  render() {
    var isLogin = (this.props.isLogin !== null && this.props.isLogin !== undefined && this.props.isLogin === "true")

    return <div>

      <Switch>
        <Route exact path="/" component={Splash} />
        <Route exact path="/authenticationHome" component={AuthenticationHome} />
        <Route exact path="/authenticationMobile" component={AuthenticationMobile} />
        <Route exact path="/authenticationCode" component={AuthenticationCode} />

        {isLogin && (
          <Route exact path="/dashboard" component={Dashboard} />
        )}

        {isLogin && (
          <Route exact path="/profile" component={Profile} />
        )}

        {isLogin && (
          <Route exact path="/releases" component={ReleaseHome} />
        )}

        {isLogin && (
          <Route exact path="/releases/detail" component={ReleaseDetail} />
        )}

        {isLogin && (
          <Route exact path="/releases/detail/releaseNote" component={ReleaseNote} />
        )}

        {isLogin && (
          <Route exact path="/releases/list" component={ReleaseList} />
        )}

        <Route component={NotFound} />
      </Switch>
    </div>
  }
}

export default Routes;
